import { archiveTimeline } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';

const tagStyle: Record<string, string> = {
  黑料合集: 'bg-primary-100 text-primary-700',
  黑料整理: 'bg-accent-100 text-accent-900',
  黑料存档: 'bg-secondary-100 text-secondary-900',
  黑料大全: 'bg-secondary-200 text-secondary-900',
};

export default function ArchiveTimeline() {
  return (
    <section id="archive" className="border-b border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-6 md:py-16 lg:px-10">
        <SectionHeading
          kicker="黑料存档"
          title="按时间归档的存档记录"
          desc="每完成一批整理就会写进存档日志，日期、题材、改动说明都留着，方便回溯这一页是怎么补全的。"
          accent="primary"
          action={{ label: '存档规范', href: '#archive' }}
        />

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6">
          {archiveTimeline.map((item, index) => (
            <Reveal key={item.title} delay={index * 60}>
              <article className="flex h-full gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5">
                <div className="flex shrink-0 flex-col items-center">
                  <div className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-500 font-heading text-base font-bold text-background-50">
                    {item.date}
                  </div>
                  <span className="mt-2 h-full w-px flex-1 bg-background-300"></span>
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="flex flex-wrap items-center gap-2">
                    <span
                      className={`rounded px-2 py-0.5 text-xs ${
                        tagStyle[item.tag] ?? 'bg-secondary-100 text-secondary-900'
                      }`}
                    >
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.weekday}</span>
                  </div>
                  <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                  <div className="mt-3 flex items-center justify-between">
                    <span className="flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-history-line"></i>
                      已核对来源
                    </span>
                    <img
                      src={item.image}
                      alt={item.alt}
                      title={item.title}
                      className="h-12 w-12 rounded-md object-cover"
                    />
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}